export const CATEGORY_TYPE_FURNITURE = 'FURNITURE' as const;
export const CATEGORY_TYPE_SYSTEM = 'SYSTEM' as const;
export const CATEGORY_TYPE_ACCESSORIES = 'ACCESSORIES' as const;
export const CATEGORY_TYPE_ICONIC = 'ICONIC' as const;

export const CATEGORY_TYPES = [
  CATEGORY_TYPE_FURNITURE,
  CATEGORY_TYPE_SYSTEM,
  CATEGORY_TYPE_ACCESSORIES,
  CATEGORY_TYPE_ICONIC,
];
